import { useState, useContext, useEffect } from "react";
import { Navbar, Button, Offcanvas } from "react-bootstrap";
import WhiteLogo from "../../assets/images/full-white-logo.png";
import BlackLogo from "../../assets/images/full-black-logo.png";
import LogoBonus from "../../assets/images/logo-bonus.png";
import { useNavigate } from "react-router";
import { useMediaQuery } from "react-responsive";
import { Context } from "../../App";
import DarkModeToggle from "react-dark-mode-toggle";

export const Default = () => {
  const { statusMode, setStatusMode } = useContext(Context);
  const navigate = useNavigate();
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 450 });
  const toggleDarkMode = () => {
    setStatusMode(!statusMode);
    
  };

  useEffect(() => {
    
      if (statusMode) {
        
        document.documentElement.className = "dark-theme";
        document.documentElement.setAttribute('data-bs-theme', 'dark-theme');
        document.body.classList.add("dark-mode");
      document.body.style.backgroundColor = "#0d0d0d";
      
        
      } else {
        
        document.documentElement.className = "light-theme";
        document.documentElement.setAttribute('data-bs-theme', 'light-theme');
        document.body.classList.remove("dark-mode");
        document.body.style.backgroundColor = "";
      }
      
      localStorage.setItem("statusMode", statusMode);
    }, [statusMode]);
  const redirectToInit = (e) => {
    e.preventDefault();
    navigate(`/`);
  };

  return (
    <>
      <Navbar
        className="bg-brand d-flex justify-content-between align-items-center"
        expand="sm"
        style={{ boxShadow: "0 6px 4px #0006" }}
      >
        <div className="d-flex justify-content-between align-items-center w-100 ps-2 pe-4">
          <Navbar.Brand>
            <div className="d-flex align-items-center">
              <a href="/" onClick={redirectToInit}>
                <img
                  src={statusMode ? WhiteLogo : BlackLogo}
                  alt="Logo"
                  style={{ height: "37px", width: "auto" }}
                />
              </a>
              {
              !isMobile === true &&
              <>
              <div
                className="bg-light me-2"
                style={{ height: "37px", width: "3px" }}
              ></div>

              
              <a href="/" onClick={redirectToInit}>
                <img
                  src={LogoBonus}
                  alt="Logo-Bonus"
                  style={{ height: "30px", width: "auto" }}
                />
              </a>
              </>
              }
            </div>
          </Navbar.Brand>
          <div className="d-none d-sm-block">
            <DarkModeToggle
              checked={statusMode}
              onChange={toggleDarkMode}
              size={70}
              speed={1.3}
            />
          </div>

          <div className="d-flex align-items-center d-sm-none">
            <Button
              variant="success"
              onClick={() => setShowOffcanvas(true)}
              className="navbar-toggler"
              aria-label="Open Menu"
            >
              <span className="navbar-toggler-icon"></span>
            </Button>
          </div>
        </div>
      </Navbar>

      <Offcanvas
        show={showOffcanvas}
        onHide={() => setShowOffcanvas(false)}
        placement="end"
        className="bg-brand"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div>
              <a href="/" onClick={redirectToInit}>
                <img
                  src={statusMode ? WhiteLogo : BlackLogo}
                  alt="Logo"
                  style={{ height: "37px", width: "auto" }}
                />
              </a>
            </div>

            <div className="bg-light mb-2 mt-1" style={{width:"200px", height:"3px", marginLeft:"13px"}}>
 
            </div>

            <div>
              <a href="/" onClick={redirectToInit}>
                <img
                  src={LogoBonus}
                  alt="Logo-Bonus"
                  style={{ height: "30px", width: "auto", marginLeft:"13px" }}
                />
              </a>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="w-100 d-flex justify-content-center">
            <DarkModeToggle
              className="toggler"
              checked={statusMode}
              onChange={toggleDarkMode}
              size={70}
              speed={1.3}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Default;